import React from 'react';
import {defineMessage} from 'react-intl';
import type {FilterProps} from '@igp/shared/components/filter';
import {SelectFilter} from '@igp/shared/components/filter';
import type {SelectOption} from '@igp/shared/components/select';
import {useBoUserGroups} from '@igp/shared/features/bo-user-group';

import {allRoles} from '../constants';

const label = defineMessage({
    id: 'RolesFilter_label',
    defaultMessage: 'Role',
});

type RolesFilterProps = FilterProps<string[]>;

export function RolesFilter(props: RolesFilterProps) {
    const {items} = useBoUserGroups({
        viewType: 'RolesFilter',
        fields: ['id', 'name'],
    });
    const itemsNames = items.map(i => i.name);

    const options = allRoles
        .filter(role => itemsNames.includes(role))
        .sort()
        .map<SelectOption>(role => ({
            value: items.find(item => item.name === role)?.id,
            label: role,
        }));

    return <SelectFilter {...props} options={options} label={label} />;
}
